export enum CouponFilter {
  Any = "any",
  None = "none",
}

export const COUPON_FILTER_LABELS: Record<CouponFilter, string> = {
  [CouponFilter.Any]: "Qualsiasi coupon",
  [CouponFilter.None]: "Nessun coupon",
};
